module.exports = __webpack_public_path__ + "img/insta-1.30e5976e.png";